import { Box } from "@mui/material";
import { FooterLayout, SSFLogo } from "@ssf/components";
import { useTranslation } from "react-i18next";

export const Footer = () => {
  const { t } = useTranslation("TraditionalClubs", { keyPrefix: "Footer" });

  return (
    <FooterLayout
      logos={
        <Box
          component="a"
          href="https://schack.se"
          sx={{ display: "block", svg: { display: "block" } }}
        >
          <SSFLogo />
        </Box>
      }
    >
      <div>
        <strong>{t("organization")}</strong>
      </div>
      <div>{t("visitingAddress")}</div>
      <div>
        <a href={`mailto:${t("email")}`}>{t("email")}</a>
      </div>
      <div>
        <a href={`tel:${t("phone")}`}>{t("phone")}</a>
      </div>
    </FooterLayout>
  );
};
